import { c as _c } from "react/compiler-runtime";
import { LayoutContainer, Section } from '@petsmart-ui/sparky';
import type { StandardTilesProps } from '../types';
import StandardTile from './StandardTile';
export default function StandardTiles(t0) {
  const $ = _c(7);
  const {
    title,
    tiles
  } = t0;
  let t1;
  if ($[0] !== tiles) {
    t1 = tiles.map(_temp);
    $[0] = tiles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tiles-4">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== title) {
    t3 = <LayoutContainer className="tiles4-container" data-testid="tiles4-standard"><Section title={title}>{t2}</Section></LayoutContainer>;
    $[4] = t2;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(item) {
  return <StandardTile {...item} key={item.sysId} />;
}